import * as XLSX from 'xlsx';
import { fetchOwnership } from '../Admin/ContentOwnership/contentOwnershipApi';
import {
  EXPORT_PAGE_SIZE,
  mapOwnershipToExportRow,
  buildExportFilename,
  validateExportRecordCount
} from './contentOwnershipExportUtils';

export const collectOwnershipRecords = async (filters = {}, { onProgress } = {}) => {
  const first = await fetchOwnership({
    ...filters,
    page: 1,
    limit: EXPORT_PAGE_SIZE
  });

  if (!first.ok) {
    throw new Error(first.message || 'Export failed');
  }

  const totalRecords = first.data?.pagination?.totalRecords || 0;
  validateExportRecordCount(totalRecords);

  const records = [...(first.data?.items || [])];
  const totalPages = first.data?.pagination?.totalPages || (records.length ? 1 : 0);

  if (typeof onProgress === 'function') {
    onProgress({ page: 1, totalPages: totalPages || 1 });
  }

  for (let page = 2; page <= totalPages; page += 1) {
    const next = await fetchOwnership({
      ...filters,
      page,
      limit: EXPORT_PAGE_SIZE
    });

    if (!next.ok) {
      throw new Error(next.message || 'Export failed');
    }

    records.push(...(next.data?.items || []));

    if (typeof onProgress === 'function') {
      onProgress({ page, totalPages });
    }
  }

  return records;
};

export const exportOwnershipToExcel = (items = [], filters = {}) => {
  if (!Array.isArray(items) || items.length === 0) {
    return;
  }

  validateExportRecordCount(items.length);

  const excelData = items.map((item) => mapOwnershipToExportRow(item));
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Content Ownership');
  XLSX.writeFile(workbook, buildExportFilename(filters));
};

export const exportAllOwnershipToExcel = async (filters = {}, options = {}) => {
  const records = await collectOwnershipRecords(filters, options);
  exportOwnershipToExcel(records, filters);
  return records;
};
